/*
 * @Author: Enzo
 * @Date: 2021-07-20 09:23:05
 * @LastEditTime: 2021-07-20 09:53:26
 * @LastEditors: Enzo
 * @Description: 
 * @FilePath: /waimai_cd_fe_greentech_c/src/assets/apis/innovate.js
 * God is watching you
 */
import { get, post, axios } from '../../utils/http';

// 查询所有申报方向
// export const getAllReportDirec = (data) => get('http://yapi.sankuai.com/thrift/mock/project/20771/api/greentech/c/dict/getAllReportDirection', data);
// export const getAllReportDirec = (data) => get('dict/getAllReportDirection', data);
export const getAllReportDirec = (data) => get('/dict/directions', data);

// 保存接口
export const saveBaseInfo = (data) => post('/organization/saveBaseInfo', data);
// 保存接口
export const saveAdditionInfo = (data) => post('/organization/saveAdditionInfo', data);
// 保存接口
export const saveApplyInfo = (data) => post('/organization/saveApplyInfo', data);
// 提交接口
export const submitInnovate = (data) => axios.post('/organization/submitRecord', data);
// 获取文件上传参数

export function getFileParam() {
  return get('/file/getS3Token', undefined);
}

// 查询保存信息
// export const getProjectInfo = (data) => get('/organization/getProjectInfo', data);
export const getProjectInfo = (data) => get('/project/detail', data);
// 评委查询保存信息
export const getProjectByNo = (data) => get('/organization/getProjectInfoByNo', data);

/* 获取模版 */
export const getTemplateFileUrl = data => get('/file/getTemplateFileUrl', data);